import React from 'react';

const ImageSection = ({
  src,
  alt = '',
  className = ''
}) => {
  if (!src) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
    />
  );
};

export default ImageSection;